module.exports = __webpack_public_path__ + "media/images/lb/429-900d8d5c1f483247500bf8dd9cce403d.svg";